import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { NeptuneApi } from '../genericApi/neptune.api';
import { AccountNoteApiModel } from './models/accountNote.api.model';

@Injectable()
export class AccountNoteApi {

    constructor(
        private neptuneApi: NeptuneApi
    ) {}

    /**
     * Gets all of the notes associated with a specific account
     * @param accountId The account ID to get notes for
     * @returns An observable array of account notes
     */
    public getAccountNotes(accountId: number): Observable<AccountNoteApiModel[]> {
        const slug: string = `/accounts/${accountId}/notes`;

        return this.neptuneApi.api<AccountNoteApiModel[]>(
            slug,
            null,
            HttpVerbsEnum.GET,
        );
    }

    /**
     * Creates a new account note
     * @param accountId The account ID to create the note for
     * @param data The note data to create
     * @returns The ID of the created note
     */
    public createAccountNote(accountId: number, data: AccountNoteApiModel): Observable<number> {
        const slug: string = `/accounts/${accountId}/notes`;

        return this.neptuneApi.api<number>(
            slug,
            data,
            HttpVerbsEnum.POST,
        );
    }

    /**
     * Updates an existing account note
     * @param accountId The account ID to update the note for
     * @param noteId The note ID to update
     * @param data The updated note data
     * @returns The updated account note
     */
    public updateAccountNote(accountId: number, noteId: number, data: AccountNoteApiModel): Observable<AccountNoteApiModel> {
        const slug: string = `/accounts/${accountId}/notes/${noteId}`;

        return this.neptuneApi.api<AccountNoteApiModel>(
            slug,
            {value: data.value},
            HttpVerbsEnum.PUT,
        );
    }

    /**
     * Deletes an existing account note
     * @param accountId The account ID to delete the note for
     * @param noteId The note ID to delete
     * @returns
     */
    public deleteAccountNote(accountId: number, noteId: number): Observable<void> {
        const slug: string = `/accounts/${accountId}/notes/${noteId}`;

        return this.neptuneApi.api<void>(
            slug,
            null,
            HttpVerbsEnum.DELETE,
        );
    }
}
